










































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";

import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import Customer from "@/types/customer/Customer";
import Endpoint from "@/utils/endpoint";
import CustomerService from "@/services/customerService";
import { Watch } from "vue-property-decorator";

const namespace = "account";
@Component({
  data: () => ({
    required: (v: any) => !!v || "This field is required",
  }),
})
export default class ModalAccountGroupDetail extends Vue {
  @Getter("getModalAccountGroupingState", { namespace })
  modalAccountGroupingState!: boolean;

  @Action("setModalAccountGroupingState", { namespace })
  setModalAccountGroupingState!: any;
  @Getter("getCustomers", { namespace: "customer" }) customers!: Customer[];
  @Action("setCustomers", { namespace: "customer" }) setCustomers!: any;
  @Getter("getLoading", { namespace }) loading!: boolean;

  @Action("setLoading", { namespace }) setLoading!: any;

  private endpoint = new Endpoint();

  customersWithAcount: VuetifySelectItems[] = [];
  customersOthers: VuetifySelectItems[] = [];
  customerService = new CustomerService(this.$http);
  family = { manager: "", members: [] };
  selectedCustomers: any[] = [];
  accountLoading = false;

  private get form(): HTMLFormElement {
    return this.$refs.form as HTMLFormElement;
  }

  async makeGrouppedAccount() {
    if (this.form.validate()) {
      this.accountLoading = true;

      try {
        const url = this.endpoint.groupCustomers;

        this.$http
          .post(`${url}`, {
            accountManagerId: this.family.manager,
            familyMembers: this.family.members,
          })
          .then((res: any) => {
            this.refreshCustomer();
            this.clearFields();
            this.closeModal();
          })
          .catch((err) => {
            console.error(err);
          });

        this.accountLoading = false;
      } catch (error) {
        console.error(error);
      }
    }
  }

  refreshCustomer(): void {
    this.customers.forEach((element) => {
      if (element.id == this.family.manager) {
        element.isAccountManager = this.family.members.length > 0;
        element.familyMembers = this.family.members.map((x) => {
          const user = this.customersOthers.find((y) => y.value == x);
          return {
            email: user?.data.email,
            userId: user?.data.id,
            name: user?.data.fullName,
          };
        });
      }
    });
    this.setCustomers(this.customers);
  }

  onChangeAccount(): void {
    if (this.family.manager) {
      const item = this.customersWithAcount.find((x) => x.data.id == this.family.manager);
      if (item?.data.isAccountManager) {
        console.log("item?.data?.familyMembers", item?.data?.familyMembers);
        this.family.members = item?.data?.familyMembers
          .sort((a: any, b: any) => a.name.localeCompare(b.name))
          .map((x: any) => x.userId);
      } else this.family.members = [];
    }
  }

  closeModal(): void {
    this.clearFields();
    this.setModalAccountGroupingState(false);
  }

  clearFields() {
    this.family.manager = "";
    this.family.members = [];
    this.form.reset();
  }
  get likesAllCustomer() {
    return this.family.members.length === this.customersOthers.length;
  }

  get likesSomeCustomers() {
    return this.family.members.length > 0 && !this.likesAllCustomer;
  }
  get icon() {
    if (this.likesAllCustomer) return "mdi-close-box";
    if (this.likesSomeCustomers) return "mdi-minus-box";
    return "mdi-checkbox-blank-outline";
  }

  toggleSelectAll() {
    this.$nextTick(() => {
      if (this.likesAllCustomer) {
        this.family.members = [];
      } else {
        this.family.members = this.customersOthers.map((x) => x.value as never);
      }
    });
  }

  @Watch("modalAccountGroupingState")
  async getCustomers(): Promise<void> {
    this.accountLoading = true;
    const customerOrdened = [...this.customers];
    customerOrdened.sort((a, b) => a.fullName.localeCompare(b.fullName));

    const itemsForVuetifySelect = customerOrdened.map((item) => {
      return {
        text: `${item.fullName} - ${item.email}`,
        value: item.id,
        data: item,
      };
    });

    this.customersWithAcount = itemsForVuetifySelect;
    this.customersOthers = itemsForVuetifySelect.filter((x) => !x.data.isAccountManager);
    this.accountLoading = false;
  }
}
